// Register view templates into the shared registry (built in 01.init.js).
// bigbang-base templates are registered first, then project templates override them.
const _bigbangBaseFiles = import.meta.glob('../../bigbang-base/components/views/**/*.vue');
const _projectFiles = import.meta.glob('@/components/views/**/*.vue');

const _parse = (path, ref) =>
	path
		.replace(ref, '')
		.replace('.vue', '')
		.split('/')
		.map(el => el.charAt(0).toUpperCase() + el.slice(1))
		.filter(el => el !== 'Index')
		.join('');

export default defineNuxtPlugin(nuxtApp => {
	// BigBang base layer templates
	Object.entries(_bigbangBaseFiles).forEach(([path, loader]) => {
		nuxtApp.$appData.templates.set(_parse(path, '../../bigbang-base/components/views/'), loader);
	});

	// Project templates (override bigbang-base)
	Object.entries(_projectFiles).forEach(([path, loader]) => {
		nuxtApp.$appData.templates.set(_parse(path, '/components/views/'), loader);
	});
});